import React, { useRef } from "react"
import { CourseForm, CourseFormInput, SearchIcon, ClearButton } from "./course-search.component.style";

import ResetSVG from "../../svg/Reset.svg"

const CourseSearch = ({ executeSearch, query, setQuery }) => {
    const inputRef = useRef(null)

    const handleInputChange = (event) => {
        setQuery(event.target.value);
    };

    const handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            executeSearch();
            if (inputRef.current) {
                inputRef.current.blur()
            }
        }
    };

    const clearInput = (event) => {
        event.preventDefault();
        setQuery('');
    }

    return (
        <CourseForm>
            <SearchIcon />
            <CourseFormInput
                ref={inputRef}
                type="text"
                placeholder="What do you want to learn?"
                value={query}
                onChange={handleInputChange}
                onKeyPress={handleKeyPress}
            />

            {query.length > 0 && (
                <ClearButton
                    onMouseDown={clearInput}
                    onTouchStart={clearInput}
                ><ResetSVG style={{ height: "12px", width: "12px" }} /></ClearButton>
            )}
        </CourseForm>
    )
}

export default CourseSearch;